module.exports = __webpack_public_path__ + "static/media/ic_InfoCircle_fill.9f20dc06.svg";